import React, { Component } from 'react';

export default class Hello extends React.Component {
  render() {
    return <h2>Hello {this.props.name}!!</h2>
  }
}



// WEBPACK FOOTER //
// app/frontend/components/Hello.jsx